import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { configurerLeClient } from '../fournisseurs/client';
import { Administration } from './Administration';

/**
 * **Le point d'entrée, et l'ordre des deux lignes compte.**
 *
 * `configurerLeClient()` pose l'adresse de l'API, `credentials: 'include'` et les deux
 * en-têtes **avant** que quoi que ce soit s'affiche. `ra-core` déclenche ses premières
 * requêtes au montage — l'identité et les droits —, et un client non configuré les enverrait
 * vers la page elle-même, sans cookie : le symptôme serait un `401` sur une personne
 * connectée, qui ne désigne pas sa cause.
 */
configurerLeClient();

const racine = document.getElementById('racine');
if (racine === null) {
  throw new Error('Le document ne porte pas #racine : index.html a changé sans ce fichier.');
}

createRoot(racine).render(
  <StrictMode>
    <Administration />
  </StrictMode>,
);
